import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import { WfdssCaseSearchDTO } from 'src/app/_types/wfdss-case-search-dto';
@Pipe({
    name: 'protectingUnit',
    standalone: false
})
export class CaseSearchProtectingUnitPipe implements PipeTransform {

  transform(wfCase: WfdssCaseSearchDTO): string {
    let unitString = ""
    if(wfCase?.protectingUnitAtPoO?.unitIrwinId){
       unitString = unitString.concat(wfCase.protectingUnitAtPoO.unitIrwinId)
    }
    // Note: Removed for story 8157; Keeping it commented in case we need it in future.
    // if(wfCase?.protectingUnitAtPoO?.name){
    //     unitString = unitString.concat(" - ", wfCase.protectingUnitAtPoO.name)
    // }
    return unitString
  }

} 
